// Confirmation des envois Turbo (Turbo.config.forms.confirm) :
// <dialog> natif. Titre : title du bouton d'envoi (ou du formulaire), sinon
// « Confirmation » ; message : data-turbo-confirm (\n\n = paragraphes) ;
// Confirmer en rouge pour une suppression ; Échap ou Annuler : refus ; focus
// sur Annuler. Sur le bouton d'envoi (sinon le formulaire) : data-verify,
// mot à saisir (consigne data-verify-text), Confirmer désactivé tant qu'il ne
// l'est pas exactement, focus sur la saisie ; data-commit : libellé de
// Confirmer ; data-commit-class="danger" : Confirmer en rouge. Une seule
// fenêtre à la fois, refermée (refus) quand la page est quittée.
const BUTTON = 'rounded-md px-3 py-1.5 text-sm font-medium focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent';

export function confirmDialog(message, form, submitter) {
    document.getElementById('confirm-dialog')?.remove();
    const method = (form.querySelector('input[name="_method"]')?.value || form.getAttribute('method') || '').toLowerCase();
    const option = (key) => submitter?.dataset[key] ?? form.dataset[key];
    const danger = method === 'delete' || option('commitClass') === 'danger';

    const dialog = document.createElement('dialog');
    dialog.id = 'confirm-dialog';
    dialog.setAttribute('aria-labelledby', 'confirm-dialog-title');
    dialog.className = 'm-auto w-[min(28rem,calc(100%-2rem))] rounded-lg border border-line bg-panel p-0 text-ink shadow-xl backdrop:bg-black/40';

    const title = document.createElement('h2');
    title.id = 'confirm-dialog-title';
    title.className = 'border-b border-line px-4 py-3 text-[15px] font-bold';
    title.textContent = submitter?.getAttribute('title') || form.getAttribute('title') || 'Confirmation';

    const body = document.createElement('div');
    body.className = 'space-y-2 px-4 py-3 text-sm';
    message.split(/\n{2}/).forEach((piece) => {
        const paragraph = document.createElement('p');
        paragraph.textContent = piece;
        body.append(paragraph);
    });

    const cancel = document.createElement('button');
    cancel.type = 'button';
    cancel.className = `${BUTTON} border border-line bg-panel hover:bg-surface`;
    cancel.textContent = 'Annuler';
    const confirm = document.createElement('button');
    confirm.type = 'button';
    confirm.className = `${BUTTON} text-white disabled:opacity-50 ${danger ? 'bg-ko hover:opacity-90' : 'bg-accent hover:bg-accent-strong'}`;
    confirm.textContent = option('commit') || 'Confirmer';
    const actions = document.createElement('div');
    actions.className = 'flex justify-end gap-2 border-t border-line px-4 py-3';
    actions.append(cancel, confirm);

    const verify = option('verify');
    let field = null;
    if (verify) {
        const hint = option('verifyText') || `Saisir ${verify} pour confirmer`;
        field = document.createElement('input');
        field.type = 'text';
        field.autocomplete = 'off';
        field.placeholder = hint;
        field.setAttribute('aria-label', hint);
        field.className = 'mt-2 block w-full rounded-md border border-field-line bg-panel px-3 py-1.5 text-base sm:text-sm';
        body.append(field);
        confirm.disabled = true;
        field.addEventListener('input', () => { confirm.disabled = field.value !== verify; });
        field.addEventListener('keydown', (event) => {
            if (event.key !== 'Enter') return;
            event.preventDefault();
            if (!confirm.disabled) dialog.close('confirm');
        });
    }

    dialog.append(title, body, actions);
    return new Promise((resolve) => {
        let done = false;
        const finish = (confirmed) => {
            if (done) return;
            done = true;
            document.removeEventListener('turbo:before-cache', onCache);
            window.removeEventListener('pagehide', onCache);
            dialog.remove();
            resolve(confirmed);
        };
        // Page quittée fenêtre ouverte (cache Turbo, ou cache de navigation du
        // navigateur pour une page chargée en entier) : refus, retirée tout de
        // suite (l'événement close arriverait après l'instantané).
        const onCache = () => {
            dialog.close('cancel');
            finish(false);
        };
        document.addEventListener('turbo:before-cache', onCache);
        window.addEventListener('pagehide', onCache);
        dialog.addEventListener('close', () => finish(dialog.returnValue === 'confirm'), { once: true });
        cancel.addEventListener('click', () => dialog.close('cancel'));
        confirm.addEventListener('click', () => dialog.close('confirm'));
        document.body.append(dialog);
        dialog.showModal();
        (field || cancel).focus();
    });
}
